import { AUTH } from "../actions/types";

const initialState = {
  login: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
  isValidToken: {
    isValid: true,
    isFetching: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    // #region AUTH_LOGIN

    case AUTH.AUTH_LOGIN_REQUEST:
      return {
        ...state,
        login: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case AUTH.AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        login: {
          successMessage: "U bent succesvol ingelogd.",
          errorMessage: null,
          isFetching: false,
        },
      };

    case AUTH.AUTH_LOGIN_FAIL:
      return {
        ...state,
        login: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region AUTH_LOGOUT

    case AUTH.AUTH_LOGOUT:
      return {
        ...state,
        successMessage: null,
        errorMessage: null,
        isFetching: false,
      };

    // #endregion

    // #region AUTH_IS_VALID_TOKEN

    case AUTH.AUTH_IS_VALID_TOKEN_REQUEST:
      return {
        ...state,
        isValidToken: {
          isValid: true,
          isFetching: true,
        },
      };

    case AUTH.AUTH_IS_VALID_TOKEN_SUCCESS:
      return {
        ...state,
        isValidToken: {
          isValid: action.payload.isValid,
          isFetching: false,
        },
      };

    case AUTH.AUTH_IS_VALID_TOKEN_FAIL:
      return {
        ...state,
        isValidToken: {
          isValid: false,
          isFetching: false,
        },
      };

    // #endregion

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js